import { render, staticRenderFns } from "./RipaSnackbar.vue?vue&type=template&id=09647806"
import script from "./RipaSnackbar.vue?vue&type=script&lang=js"
export * from "./RipaSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports